import * as Yup from "yup";
import { VALIDATION_MESSAGE } from "../constant/constant";

const {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  MOBILE,
  BUSSINESS,
  WEBSITE,
  POSTAL_CODE,
  DESCRIPTION,
} = VALIDATION_MESSAGE;

Yup.addMethod(
  Yup.string,
  "website",
  function (message = VALIDATION_MESSAGE.INVALID) {
    return this.test("website", message, (value) => {
      if (!value || value === "No") return true;
      return /^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.[a-z]{2,}){1,2}([\/?]\S*)?$/i.test(
        value
      );
    });
  }
);

export const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required(FIRST_NAME.REQUIRED)
    .min(2, FIRST_NAME.INVALID)
    .max(50, FIRST_NAME.INVALID)
    .matches(/^[A-Za-z\s]+$/, FIRST_NAME.INVALID),
  lastName: Yup.string()
    .required(LAST_NAME.REQUIRED)
    .min(2, LAST_NAME.INVALID)
    .max(50, LAST_NAME.INVALID)
    .matches(/^[A-Za-z\s]+$/, LAST_NAME.INVALID),
  email: Yup.string().required(EMAIL.REQUIRED).email(EMAIL.INVALID),
  verifyEmailOTP: Yup.string()
    .nullable() // Treat empty fields as null
    .notRequired() // Field is optional
    .transform((value) => (value === "" ? null : value))
    .matches(/^[0-9]+$/, "OTP must contain only numbers")
    .length(6, "OTP must be exactly 6 Digit"),
  mobile: Yup.string()
    .required(MOBILE.REQUIRED)
    .min(7, MOBILE.INVALID)
    .max(15, MOBILE.INVALID)
    .matches(/^\+?[0-9]+$/, MOBILE.INVALID),
  businessName: Yup.string()
    .required(BUSSINESS.REQUIRED)
    .min(2, BUSSINESS.INVALID)
    .max(100, BUSSINESS.INVALID)
    .matches(
      /^(?!.*\b(admin|root|test)\b)[A-Za-z0-9\s!@#$%^&*()_+=\-[\]{};':"\\|,.<>/?]+$/,
      BUSSINESS.INVALID
    ),
  website: Yup.string().required(WEBSITE.REQUIRED).website(WEBSITE.INVALID),
  postalCode: Yup.string()
    .required(POSTAL_CODE.REQUIRED)
    .min(3, POSTAL_CODE.INVALID)
    .max(12, POSTAL_CODE.INVALID),
  description: Yup.string()
    .nullable() // Treat empty fields as null
    .notRequired() // Field is optional
    .transform((value) => (value === "" ? null : value))
    .min(10, DESCRIPTION.MIN_LENGTH)
    .max(200, DESCRIPTION.MAX_LENGTH),
});
